module.exports = __webpack_public_path__ + "static/img/sm-bj.ee53c5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sm-bj.jpg
// module id = wgB0
// module chunks = 1